import React, { useEffect, useRef, useState } from 'react';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/DEPRECATED/components/form/layout'. 'app/webpack/javascripts/shared/DEPRECATED/components/form/layout.js' implicitly has an 'any' type.
import { FormLabel, FormField } from 'shared/DEPRECATED/components/form/layout';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '../../../forms/job/setup/components/available_tokens'. 'app/webpack/javascripts/forms/job/setup/components/available_tokens.js' implicitly has an 'any' type.
import AvailableTokens from '../../../forms/job/setup/components/available_tokens';
import TinyMCE from 'tinymce/localized_editor';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/DEPRECATED/components/Input'. 'app/webpack/javascripts/shared/DEPRECATED/components/Input.js' implicitly has an 'any' type.
import Input from 'shared/DEPRECATED/components/Input';

import { standardRequest } from 'shared/utils/request';
import Modal from '@grnhse/seedling/lib/azalea/components/modals/modal';
import ConfirmModal from '@grnhse/seedling/lib/azalea/components/modals/confirm_modal';
import Dropdown from '@grnhse/seedling/lib/azalea/components/dropdown_select';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/modals/use_modal'. 'node_modules/@grnhse/seedling/lib/azalea/components/modals/use_modal.js' implicitly has an 'any' type.
import useModal from '@grnhse/seedling/lib/azalea/components/modals/use_modal';
import {
  Card,
  CardBody,
  CardHeader,
  // @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/card'. 'node_modules/@grnhse/seedling/lib/azalea/components/card.js' implicitly has an 'any' type.
} from '@grnhse/seedling/lib/azalea/components/card';
import Button from '@grnhse/seedling/lib/azalea/components/button';
import { PreviewIcon } from '@grnhse/seedling/lib/azalea/icons';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/components/required'. 'app/webpack/javascripts/shared/components/required.js' implicitly has an 'any' type.
import Required from 'shared/components/required';
import t from 'shared/utils/translation';
import EmailTemplateFooter from '../email_template_footer';
// @ts-expect-error - TS7016 - Could not find a declaration file for module './modal_body'. 'app/webpack/javascripts/gdpr/components/consent_extension_emails/modal_body.js' implicitly has an 'any' type.
import { ModalBody } from './modal_body';
import styled, { css, useTheme } from 'styled-components';
import { colors, fontWeight } from '@grnhse/seedling/lib/azalea/constants';
import { replaceAutoGenerateTinyMceText } from './replace_auto_generate_tiny_mce_text';
// @ts-expect-error - TS7016 - Could not find a declaration file for module './consent_extension_email.styles'. 'app/webpack/javascripts/gdpr/components/consent_extension_emails/consent_extension_email.styles.js' implicitly has an 'any' type.
import { DescriptionContainer } from './consent_extension_email.styles';
import { ContentHeader } from '../components';
import { errorsPresent, getErrors, Errors } from './validation';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/utils/scrolling'. 'app/webpack/javascripts/shared/utils/scrolling.js' implicitly has an 'any' type.
import { scrollToClass } from 'shared/utils/scrolling';
import Divider, { FooterDivider } from '../shared/divider';
import { getCardGutter } from '../shared/card';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import TinyMCEConfig from '../../../tinymce/config';

const ERROR_CLASS = '__form-field-error';
const scrollToFirstError = () => {
  scrollToClass(ERROR_CLASS);
};

export function EditView({
  period,
  from,
  body,
  subject,
  froms,
  tokens,
  setIsEditing,
  save,
  initialErrors = {},
  validationValuesPath,
}: {
  period: number;
  from: any;
  body: string;
  subject: string;
  froms: any[];
  tokens: string[];
  setIsEditing: (editing: boolean) => void;
  save: (toSave: any) => any;
  initialErrors: any;
  validationValuesPath: string;
}) {
  const [isPreviewOpen, openPreviewModal, closePreviewModal] = useModal(false);
  const [errors, setErrors] = useState<Errors>({
    period: initialErrors.consent_period,
    from: null,
    subject: null,
    body: null,
  });
  const [values, setValues] = useState({
    from: !!from ? from : null,
    // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
    period: !!period ? parseInt(period, 10) : '',
    subject: !!subject ? subject : '',
    body: !!body ? body : '',
  });

  const [shortestRetentionPeriod, setShortestRetentionPeriod] = useState();
  const [maxConsentPeriod, setMaxConsentPeriod] = useState();
  const emailOptions = !!froms ? froms : [];
  const tokenList = !!tokens ? tokens : [];
  const periodReference = useRef(null);
  const subjectReference = useRef(null);
  const theme = useTheme();

  useEffect(() => {
    standardRequest.get(validationValuesPath).then(
      ({
        data: {
          shortest_retention_period: shortRetentionPeriod,

          maximum_consent_period: maximumConsentPeriod,
        },
      }) => {
        setShortestRetentionPeriod(shortRetentionPeriod);
        setMaxConsentPeriod(maximumConsentPeriod);
      }
    );
  }, [validationValuesPath]);

  const cleanHighlightedError = (field: string) => {
    setErrors({
      ...errors,
      [field]: undefined,
    });
  };

  const handleChange = (field: string, value: string) => {
    setValues({
      ...values,
      [field]: value,
    });
  };

  async function processSaving() {
    const {
      data: { shortest_retention_period: shortRetentionPeriod },
    } = await standardRequest.get(validationValuesPath);

    setShortestRetentionPeriod(shortRetentionPeriod);
    const currentErrors = getErrors(values, shortRetentionPeriod);

    if (errorsPresent(currentErrors)) {
      setErrors(currentErrors);
      scrollToFirstError();
    } else {
      save(values);
    }
  }

  return (
    <React.Fragment>
      <Card
        useLegacyPadding
        data-provides="gdpr_consent_extension_email"
        className="gdpr-consent-extension-email"
      >
        <CardHeader
          label={t('gdpr.consent_extension_email.title')}
          labelSize="large"
        />

        <CardBody
          verticalCardGutter="medium"
          cardGutter={getCardGutter(false)}
          key="gdpr_edit_view_body"
        >
          {consentPeriodField(
            values,
            errors.period,
            handleChange,
            periodReference,
            cleanHighlightedError,
            shortestRetentionPeriod,
            maxConsentPeriod
          )}
          <Divider />
          {fromField(
            emailOptions,
            values,
            errors.from,
            handleChange,
            cleanHighlightedError
          )}
          {subjectField(
            values,
            errors.subject,
            handleChange,
            subjectReference,
            cleanHighlightedError
          )}
          {bodyField(
            tokenList,
            values,
            errors.body,
            handleChange,
            cleanHighlightedError
          )}
          <FooterDivider />
          <ButtonContainer>
            <ConfirmModal
              title={t(
                'gdpr.consent_extension_email.cancel_confirmation_title'
              )}
              confirmText={t(
                'gdpr.consent_extension_email.cancel_confirmation_text'
              )}
              submitText={t(
                'gdpr.consent_extension_email.cancel_confirmation_confirm'
              )}
              cancelText={t(
                'gdpr.consent_extension_email.cancel_confirmation_cancel'
              )}
              maxWidth="md"
              onConfirm={() => setIsEditing(false)}
            >
              <CancelButton
                hideBg
                onClick={() => setIsEditing(false)}
                theme={theme}
              >
                {t('gdpr.consent_extension_email.action_cancel')}
              </CancelButton>
            </ConfirmModal>
            {/* @ts-expect-error - TS2769 - No overload matches this call. */}
            <ButtonItem marginRight="16">
              <Button onClick={openPreviewModal}>
                <WithMargin>
                  <PreviewIcon
                    size={10}
                    color={
                      // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'DefaultTheme'.
                      theme?.name === 'birch'
                        ? FullPalette.GREEN_700
                        : undefined
                    }
                  />
                </WithMargin>
                {t('gdpr.consent_extension_email.action_preview')}
              </Button>
              <Modal
                open={isPreviewOpen}
                closeModal={closePreviewModal}
                title={t('gdpr.consent_extension_email.preview_header')}
                fullScreen={false}
                width={'668px'}
              >
                <ModalBody
                  previewEmail={values.body}
                  closePreviewModal={closePreviewModal}
                />
              </Modal>
            </ButtonItem>
            <Button fancy onClick={() => processSaving()}>
              {t('gdpr.consent_extension_email.action_save')}
            </Button>
          </ButtonContainer>
        </CardBody>
      </Card>
    </React.Fragment>
  );
}

// eslint-disable-next-line max-params
function consentPeriodField(
  // @ts-expect-error - TS7006 - Parameter 'values' implicitly has an 'any' type.
  values,
  error: string | null | undefined,
  handleChange: (field: string, value: any | string) => void,
  controlReference: {
    current: null | React.ElementRef<any>;
  },
  cleanHighlightedError: (field: string) => void,
  // @ts-expect-error - TS7006 - Parameter 'shortestRetentionPeriod' implicitly has an 'any' type.
  shortestRetentionPeriod,
  // @ts-expect-error - TS7006 - Parameter 'maxRetentionPeriod' implicitly has an 'any' type.
  maxRetentionPeriod
) {
  return (
    <FormField error={error}>
      <FormLabel>
        {t('gdpr.consent_extension_email.description')}
        <MarginedContentHeader top={14}>
          {t('gdpr.consent_extension_email.period.header')}
        </MarginedContentHeader>
        <BottomMargin bottom={14}>
          {t('gdpr.consent_extension_email.period.description')}
        </BottomMargin>
      </FormLabel>
      <PeriodEditor>
        <InputFont>
          <Input
            data-provides="consent_extension_email_window"
            width="100px"
            // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
            onChange={(e) => {
              handleChange('period', e.target.value.replace(/\D/g, ''));
              cleanHighlightedError('period');
            }}
            value={values.period}
            type="number"
            min="1"
            max={shortestRetentionPeriod || maxRetentionPeriod}
            ref={controlReference}
          />
        </InputFont>
        <FormLabelWithMargin>
          {t('gdpr.consent_extension_email.period.days')}
          <Required withLeftPadding />
        </FormLabelWithMargin>
      </PeriodEditor>
      {!error && !!shortestRetentionPeriod && (
        <PeriodMaxSizeInformation>
          {t('gdpr.consent_extension_email.validation.maxPeriod', {
            retention_period: shortestRetentionPeriod,
          })}
        </PeriodMaxSizeInformation>
      )}
    </FormField>
  );
}

function fromField(
  emailOptions: Array<any>,
  // @ts-expect-error - TS7006 - Parameter 'values' implicitly has an 'any' type.
  values,
  error: string | null | undefined,
  handleChange: (field: string, value: any | string) => void,
  cleanHighlightedError: (field: string) => void
) {
  return (
    <FormField error={error}>
      <FormLabelSmall>
        {t('gdpr.consent_extension_email.email.from')}
        <Required withLeftPadding />
      </FormLabelSmall>
      <SelectContainer>
        <Dropdown
          // @ts-expect-error - TS2322 - Type '{ id: string; options: any[]; onChange: (value: any) => void; value: any; }' is not assignable to type 'IntrinsicAttributes & Pick<Props, "value" | "className" | "onChange" | "noOptionsMessage" | "loadingMessage" | "searchPromptText" | "optionRenderer" | "onMenuOpen" | "onMenuClose"> & InexactPartial<...> & InexactPartial<...>'.
          id="consent_extension_email_from"
          options={emailOptions}
          // @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
          onChange={(value) => {
            handleChange('from', value);
            cleanHighlightedError('from');
          }}
          value={values.from}
        />
      </SelectContainer>
    </FormField>
  );
}

function subjectField(
  // @ts-expect-error - TS7006 - Parameter 'values' implicitly has an 'any' type.
  values,
  error: string | null | undefined,
  handleChange: (field: string, value: any | string) => void,
  controlReference: {
    current: null | React.ElementRef<any>;
  },
  cleanHighlightedError: (field: string) => void
) {
  return (
    <FormField error={error}>
      <FormLabelSmall>
        {t('gdpr.consent_extension_email.email.subject')}
        <Required withLeftPadding />
      </FormLabelSmall>
      <InputFont>
        <Input
          data-provides="consent_extension_email_subject"
          width="300px"
          // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
          onChange={(e) => {
            handleChange('subject', e.target.value);
            cleanHighlightedError('subject');
          }}
          value={values.subject}
          ref={controlReference}
        />
      </InputFont>
    </FormField>
  );
}

function bodyField(
  tokenList: Array<never> | Array<string>,
  // @ts-expect-error - TS7006 - Parameter 'values' implicitly has an 'any' type.
  values,
  error: string | null | undefined,
  handleChange: (field: string, value: any | string) => void,
  cleanHighlightedError: (field: string) => void
) {
  return (
    <EditorAndTokens>
      <DescriptionContainer>
        <FormLabelSmall>
          {t('gdpr.consent_extension_email.email.body')}
          <Required withLeftPadding />
        </FormLabelSmall>
        <FormField error={error}>
          {/* @ts-expect-error - TS2769 - No overload matches this call. */}
          <BodyContainer error={error}>
            <TinyMCE
              key={'consent_email.name'}
              id="consent_extension_email_body"
              initialValue={values.body}
              init={{
                ...TinyMCEConfig.EmailWithPreview,
                height: 208,
                selector: undefined,
              }}
              onChange={(e) => {
                handleChange(
                  'body',
                  // @ts-expect-error: Adjust type for TinyMCE 6
                  replaceAutoGenerateTinyMceText(e.level.content)
                );
                cleanHighlightedError('body');
              }}
            />
          </BodyContainer>
        </FormField>
        <EmailTemplateFooter
          approveText={t('gdpr.consent_extension_email.footer.keep_data')}
          bodyText={t('gdpr.consent_extension_email.footer.description')}
          denyText={t('gdpr.consent_extension_email.footer.delete_data')}
          tooltipText={t('gdpr.consent_extension_email.footer.tooltip')}
        />
      </DescriptionContainer>
      {/* @ts-expect-error - TS2769 - No overload matches this call. */}
      <TokensContainer compact>
        <FormLabelSmall>
          {t('gdpr.consent_extension_email.email.tokens')}
        </FormLabelSmall>
        <AvailableTokens tokens={tokenList} fontSize={12} />
      </TokensContainer>
    </EditorAndTokens>
  );
}

const MarginedContentHeader = styled(ContentHeader)<{ top: number }>`
  margin-top: ${(props) => props.top}px;
  color: black;
`;

const BodyContainer = styled.div`
  ${(props) =>
    // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'ThemedStyledProps<Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "key" | keyof HTMLAttributes<HTMLDivElement>> & { ...; }, any>'.
    props.error &&
    css`
      border: 1px solid ${colors.darkRed};
      padding-right: 2px;
    `}
`;

const BottomMargin = styled.div<{ bottom: number }>`
  margin-bottom: ${(props) => props.bottom}px;
  width: 695px;
`;

const PeriodEditor = styled.div`
  display: flex;
  align-items: baseline;
`;

const InputFont = styled.div`
  font-weight: 100;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const ButtonItem = styled.div<{ marginRight: number }>`
  display: inline-block;
  margin-right: ${(props) => props.marginRight}px;
`;

const FormLabelWithMargin = styled(FormLabel)`
  margin-left: 10px;
`;

const SelectContainer = styled.div`
  width: 300px;
`;

const EditorAndTokens = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: -3px;
`;

const TokensContainer = styled.div`
  width: 274px;
  margin-right: 41px;
`;
const FormLabelSmall = styled(FormLabel)`
  font-size: 12px;
  margin-bottom: 3px;
`;

const PeriodMaxSizeInformation = styled.div`
  color: ${colors.darkGrey};
  font-weight: ${fontWeight.normal};
  padding-top: 8px;
`;

export const WithMargin = styled.span`
  margin-right: 10px;
`;

const CancelButton = styled(Button)`
  text-decoration: ${(props) =>
    props.theme?.name === 'birch' ? 'underline' : 'none'};
`;
